import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Up = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Up' {...props}>
    <polyline fill='none' stroke='#000' strokeWidth='2' points='7.086 1.174 17.086 11.174 7.086 21.174' transform='rotate(-89 12.086 11.174)' />
  </StyledIcon>
);
